import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';

function Frontend() {
    const navigate = useNavigate();
    const location = useLocation();
      const [notifs, setNotifs] = useState(0);
    const [bal, setBal] = useState("0.00");
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const navrto = (path) => {
        navigate("/" + path);
        setSidebarOpen(false);
    }

    const logout2 = () => {
        localStorage.clear();
        navigate("/login");
    }

    const isActiveRoute = (path) => {
        return location.pathname === path;
    };

    return (
        <div className="d-flex flex-column min-vh-100 bg-light">
            <Helmet>
                <title>Fx4Money</title>
                <meta name="description" content="Trade Forex, Crypto and Metals with AUROFX MARKET" />
            </Helmet>

            {/* Fixed Header */}
            <header className="fixed-top bg-primary text-white shadow-sm">
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between py-2">
                        {/* Left Section */}
                        <div className="d-flex align-items-center">                            
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 fw-bold">
                                      <i className="bi bi-graph-up me-2"></i> Fx4Money</h5>
                            </div>
                        </div>

                        {/* Center Section - Balance 
                        <div className="d-none d-md-block">
                            <div className="bg-white bg-opacity-25 rounded-pill px-3 py-1">
                                <small className="me-2">Balance:</small>
                                <strong>${bal}</strong>
                            </div>
                        </div>*/}

                        {/* Right Section */}
                        <div className="d-flex align-items-center">
                            {/* <Link to="/notifications" className="btn btn-outline-light btn-sm position-relative me-2">
                                <i className="fas fa-bell"></i>
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                    {notifs.legnth}
                                </span>
                            </Link> */}
                            <Link to="/settings" className="btn btn-outline-light btn-sm">
    <img src="https://icons.veryicon.com/png/o/business/multi-color-financial-and-business-icons/user-139.png" 
                                    alt="Profile" className="rounded-circle" style={{width: '24px', height: '24px'}}/>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* Sidebar Modal */}
            <div className={`modal fade ${sidebarOpen ? 'show' : ''}`} style={{display: sidebarOpen ? 'block' : 'none'}} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <div className="d-flex align-items-center w-100">
                                <img 
                                    src="https://icons.veryicon.com/png/o/business/multi-color-financial-and-business-icons/user-139.png" 
                                    alt="User" 
                                    className="rounded-circle me-3"
                                    style={{width: '50px', height: '50px'}}
                                />
                                <div className="flex-grow-1">
                                    <h6 className="mb-0 fw-bold">{localStorage.getItem('name') || 'User'}</h6>
                                    <small className="opacity-75">Client ID #000{localStorage.getItem('userid')}</small>
                                </div>
                            </div>
                            <button 
                                type="button" 
                                className="btn-close btn-close-white" 
                                onClick={() => setSidebarOpen(false)}
                            ></button>
                        </div>
                        
                        <div className="modal-body p-0">
                            {/* Balance Card */}
                            <div className="bg-primary text-white p-4 text-center">
                                <small className="opacity-75">Available Balance</small>
                                <h3 className="mb-0 fw-bold">${bal}</h3>
                            </div>

                            {/* Navigation Menu */}
                            <div className="p-3">
                                <h6 className="text-muted mb-3">ACCOUNT</h6>
                                <div className="list-group list-group-flush">
                                    <button 
                                        onClick={() => navrto('profile')}
                                        className="list-group-item list-group-item-action border-0"
                                    >
                                        <i className="fas fa-user-circle text-primary me-3"></i>
                                        Manage Profile
                                    </button>
                                    <button 
                                        onClick={() => navrto('password')}
                                        className="list-group-item list-group-item-action border-0"
                                    >
                                        <i className="fas fa-lock text-primary me-3"></i>
                                        Change Password
                                    </button>
                                    <button 
                                        onClick={() => navrto('bank')}
                                        className="list-group-item list-group-item-action border-0"
                                    >
                                        <i className="fas fa-university text-primary me-3"></i>
                                        Bank Details
                                    </button>
                                </div>

                                <h6 className="text-muted mb-3 mt-4">SUPPORT</h6>
                                <div className="list-group list-group-flush">
                                    <button 
                                        onClick={() => navrto('company')}
                                        className="list-group-item list-group-item-action border-0"
                                    >
                                        <i className="fas fa-building text-primary me-3"></i>
                                        About Company
                                    </button>
                                    <button 
                                        onClick={() => navrto('contact')}
                                        className="list-group-item list-group-item-action border-0"
                                    >
                                        <i className="fas fa-headset text-primary me-3"></i>
                                        Contact Support
                                    </button>
                                </div>

                                <div className="list-group list-group-flush mt-4">
                                    <button 
                                        onClick={logout2}
                                        className="list-group-item list-group-item-action border-0 text-danger"
                                    >
                                        <i className="fas fa-sign-out-alt me-3"></i>
                                        Log Out
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop for modal */}
            {sidebarOpen && (
                <div 
                    className="modal-backdrop fade show" 
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}

            {/* Main Content */}
            <main className="flex-grow-1" style={{marginTop: '70px', marginBottom: '70px'}}>
                <div className="container-fluid py-3">
                    <Outlet />
                </div>
            </main>

            {/* Fixed Footer Navigation */}
            <footer className="fixed-bottom bg-white shadow-lg border-top">
                <div className="container-fluid">
                    <div className="row g-0">
                        <div className="col-3">
                            <Link 
                                to="/dashboard" 
                                className={`btn btn-link w-100 py-3 text-decoration-none ${
                                    isActiveRoute('/dashboard') ? 'text-primary' : 'text-muted'
                                }`}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <i className={`fas fa-home ${isActiveRoute('/dashboard') ? 'fs-5' : 'fs-6'}`}></i>
                                    <small className="mt-1">HOME</small>
                                </div>
                            </Link>
                        </div>
                        <div className="col-3">
                            <Link 
                                to="/tradelist" 
                                className={`btn btn-link w-100 py-3 text-decoration-none ${
                                    isActiveRoute('/tradelist') ? 'text-primary' : 'text-muted'
                                }`}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <i className={`fas fa-shopping-bag ${isActiveRoute('/tradelist') ? 'fs-5' : 'fs-6'}`}></i>
                                    <small className="mt-1">ORDERS</small>
                                </div>
                            </Link>
                        </div>
                        <div className="col-3">
                            <Link 
                                to="/tradebook" 
                                className={`btn btn-link w-100 py-3 text-decoration-none ${
                                    isActiveRoute('/tradebook') ? 'text-primary' : 'text-muted'
                                }`}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <i className={`fas fa-exchange-alt ${isActiveRoute('/tradebook') ? 'fs-5' : 'fs-6'}`}></i>
                                    <small className="mt-1">TRANSACTION</small>
                                </div>
                            </Link>
                        </div>
                        <div className="col-3">
                            <Link 
                                to="/settings" 
                                className={`btn btn-link w-100 py-3 text-decoration-none ${
                                    isActiveRoute('/settings') ? 'text-primary' : 'text-muted'
                                }`}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <i className={`fas fa-user ${isActiveRoute('/settings') ? 'fs-5' : 'fs-6'}`}></i>
                                    <small className="mt-1">ACCOUNT</small>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Frontend;